export const ARIA_LABEL_NAMESPACE = 'ariaLabels';
export const ARIA_LABEL_KEY = 'interactions_AriaLabel_contentOnHover_message';
export const ARIA_LABEL_DEFAULT =
  'Interactive element, focus to trigger content change';

export const DisplayNames = {
  data: {
    onClick: 'On Click',
    onDblClick: 'On Double Click',
    onMouseIn: 'On Mouse In',
    onMouseOut: 'On Mouse Out',
    onFocus: 'On Focus',
    onBlur: 'On Blur',
  },
} as const;
